import { encryptedFeatures, hiddenPreviews } from "@/mocks/heigua";

export default function Encrypted() {
  return (
    <section id="vault" className="relative overflow-hidden bg-ink-950 py-16 text-cream-50 md:py-24">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-ember-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-96 w-96 rounded-full bg-leaf-500/10 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          {/* 左：说明 + 权益 */}
          <div>
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-cream-50/20 bg-cream-50/5 px-4 py-1.5 text-xs tracking-wide text-cream-50/80">
              <i className="ri-lock-2-line text-ember-400" />
              ENCRYPTED · 私密分享隐藏内容
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight md:text-5xl">
              加密专区
              <span className="block mt-2 text-lg font-medium text-cream-50/70 md:text-2xl">只给真正想看下去的人开锁</span>
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-cream-50/70 md:text-base">
              普通页装不下、也放不安全的深度素材，全部归档进加密专区。这里是
              <span className="text-ember-400 font-medium">内部爆料</span>的完整版、
              <span className="text-ember-400 font-medium">独家内幕</span>的原文件，以及读者投递的私密分享隐藏内容。
            </p>

            <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {encryptedFeatures.map((f) => (
                <div key={f.title} className="rounded-xl border border-cream-50/10 bg-cream-50/5 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-ember-500/15 text-ember-400">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 text-base font-semibold text-cream-50">{f.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-cream-50/65">{f.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-ember-500 px-7 py-3.5 text-sm font-semibold text-cream-50 hover:bg-ember-600"
              >
                <i className="ri-key-2-line mr-2 text-base" />
                申请会员权限
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-cream-50/25 px-7 py-3.5 text-sm font-semibold text-cream-50 hover:border-cream-50/60"
              >
                提交私密素材
              </a>
            </div>
            <p className="mt-4 flex items-center gap-2 text-xs text-cream-50/50">
              <i className="ri-leaf-line text-leaf-500" />
              加密素材经校验后入库 · 权益说明见专区协议
            </p>
          </div>

          {/* 右：隐藏内容预览 */}
          <div className="lg:pt-10">
            <div className="overflow-hidden rounded-2xl border border-cream-50/10 bg-ink-900/60">
              <div className="flex items-center justify-between border-b border-cream-50/10 px-5 py-4">
                <div className="flex items-center gap-2">
                  <span className="h-2.5 w-2.5 rounded-full bg-ember-500" />
                  <span className="h-2.5 w-2.5 rounded-full bg-cream-50/20" />
                  <span className="h-2.5 w-2.5 rounded-full bg-cream-50/20" />
                  <span className="ml-2 text-xs text-cream-50/60">隐藏内容 · 阅后即焚预览</span>
                </div>
                <span className="text-xs text-ember-400">
                  <i className="ri-lock-line mr-1" />
                  需会员开锁
                </span>
              </div>

              <div className="flex flex-col divide-y divide-cream-50/5">
                {hiddenPreviews.map((h) => (
                  <div key={h.label} className="px-5 py-5">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-cream-50">{h.label}</span>
                      <span className="whitespace-nowrap text-[11px] text-cream-50/50">{h.level}</span>
                    </div>
                    <p className="mt-2 select-none text-sm leading-relaxed text-cream-50/60 blur-[3px]">{h.text}</p>
                    <div className="mt-3 flex items-center gap-2">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-ember-400 hover:text-ember-300"
                      >
                        <i className="ri-lock-2-line" />
                        开锁阅读隐藏内容
                      </a>
                      <span className="text-cream-50/25">·</span>
                      <span className="text-xs text-cream-50/45">
                        <i className="ri-time-line mr-1" />
                        剩余 47 分钟
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between border-t border-cream-50/10 px-5 py-4">
                <span className="text-xs text-cream-50/55">
                  <i className="ri-shield-check-line mr-1 text-leaf-500" />
                  三重校验 · 无痕浏览
                </span>
                <span className="flex items-center gap-3 text-xs text-cream-50/55">
                  <span>不保存</span>
                  <span>不转发</span>
                  <span>不留痕</span>
                </span>
              </div>
            </div>

            <div className="mt-5 rounded-xl border border-ember-500/25 bg-ember-500/10 px-5 py-4 text-sm text-cream-50/75">
              <span className="font-medium text-ember-400">私密分享提示：</span>
              部分加密素材设有时效，超时自动归档，请及时翻阅。敏感截图均带水印，请勿外传，共同守好这间黑屋。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}